(ns common.resource.query.template
  (:require [cljs-bean.core :refer [->clj]]
            [common.db.effects.http :refer [jsonify]]
            [common.queries.http :as qhttp]
            [manage.resource.template :refer [get-latest-revision response->manage-api-format]]))

(def pre-made-template-folder-id 99999)

(defn templates-query [{:keys [advertiser-id]}]
  #js {:queryKey #js ["templates" advertiser-id]
       :queryFn (fn [_ctx] (qhttp/get (qhttp/render :api/advertiser-templates {}
                                                    {:advertiser-id advertiser-id
                                                     :embed (jsonify ["revisions"])})))
       :enabled (boolean advertiser-id)
       :select (fn [data]
                 (->> (->clj data)
                      response->manage-api-format
                      :data
                      (mapv #(assoc % :latestRevision (get-latest-revision %)))))
       :staleTime (* 60 1000)})

(defn pre-made-templates-query [& {:keys [channel]}]
  #js {:queryKey #js ["pre-made-templates"]
       :queryFn (fn [_ctx] (qhttp/get (qhttp/render :api/advertiser-pre-made-templates {})))
       :select (fn [data]
                 (-> (->clj data)
                     response->manage-api-format
                     (->> (mapv #(assoc % :latestRevision (get-latest-revision %)
                                        :pre-made-template true
                                        :folderId pre-made-template-folder-id)))
                     (cond->>
                       channel (filter #(= (if (= channel "display") "html" "after-effects")
                                           (get-in % [:latestRevision :templateType]))))))})
